import { render } from "./ProductSectionShowComponent.vue?vue&type=template&id=bd3f7a86"
import script from "./ProductSectionShowComponent.vue?vue&type=script&lang=js"
export * from "./ProductSectionShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/productSections/ProductSectionShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd3f7a86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd3f7a86', __exports__)) {
    api.reload('bd3f7a86', __exports__)
  }
  
  module.hot.accept("./ProductSectionShowComponent.vue?vue&type=template&id=bd3f7a86", () => {
    api.rerender('bd3f7a86', render)
  })

}


export default __exports__